module.exports = __webpack_public_path__ + "static/12-670aac3c03b2cd61f9eca351dfe47390.jpeg";